module.exports = [{
      plugin: require('/Users/miked/Documents/smartfinancenews.com/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
